/**
 * @generated SignedSource<<afc011698c9099cfca94add1ab3df163>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeRoleEditEmployeesDialog_EmployeeConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditEmployeesDialog_EmployeeItem">;
    };
  }>;
  readonly " $fragmentType": "EmployeeRoleEditEmployeesDialog_EmployeeConnection";
};
export type EmployeeRoleEditEmployeesDialog_EmployeeConnection$key = {
  readonly " $data"?: EmployeeRoleEditEmployeesDialog_EmployeeConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditEmployeesDialog_EmployeeConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeRoleEditEmployeesDialog_EmployeeConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmployeeRoleEditEmployeesDialog_EmployeeItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeConnection",
  "abstractKey": null
};

(node as any).hash = "94eef69d817b6d3e75698b53cc7ad91f";

export default node;
